module.exports = __webpack_public_path__ + "static/media/afghanWomen.fd49fc9a.svg";